import React from "react";
import {
  Pagination as PolarisPagination,
  Text,
  BlockStack,
} from "@shopify/polaris";

const Pagination = ({ currentPage, setCurrentPage, totalPages }) => {
  const hasPrevious = currentPage > 1;
  const hasNext = currentPage < totalPages;

  if (totalPages <= 1) return null;

  return (
    <BlockStack align="center" gap="400">
      <PolarisPagination
        label={
          <Text variant="bodyMd" fontWeight="medium">
            Page {currentPage} of {totalPages}
          </Text>
        }
        hasPrevious={hasPrevious}
        onPrevious={() => setCurrentPage((prev) => prev - 1)}
        hasNext={hasNext}
        onNext={() => setCurrentPage((prev) => prev + 1)}
        previousKeys={[74]}
        nextKeys={[75]}
      />
    </BlockStack>
  );
};

export default Pagination;
